/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Payment } from "./Payment";
import * as t from "io-ts";

// required attributes
const PaymentResponseR = t.interface({});

// optional attributes
const PaymentResponseO = t.partial({
  data: Payment
});

export const PaymentResponse = t.intersection(
  [PaymentResponseR, PaymentResponseO],
  "PaymentResponse"
);

export type PaymentResponse = t.TypeOf<typeof PaymentResponse>;
